
import AppBrowse from "@/components/browse/Browse.vue";
import {Product, SaleRow} from "@/models/base";
import { BrowseService } from "@/services/browse-service";
import { SaleRowService, PurchaseDocumentRowService, SaleRowServiceClass } from "@/services/sale-row-service";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import { HumanFilter } from "@/utils/human-filter";
import { IQueryParams } from "@/utils/query-params";
import Vue from "vue";
import { BookYearService } from "@/services/book-year-service";
import AppSelectBookYear from "@/components/bookyear/SelectBookYear.vue";
import { AuthService } from "@/services/auth-service";
import { MODULE } from "@/config/modules";
import { ISelectItem } from "winfakt-vue-components";
import AppMarkAsDelivered from "./MarkAsDelivered.vue";
import AppMarkAsDeliveredDate from "./MarkAsDeliveredDate.vue";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { View } from "@/models/view";
import {BrowseState} from "@/utils/browse/browse-state";
import AppProductQuickEditSellPrice from "@/components/products/ProductQuickEditSellPrice.vue";
import AppProductQuickEditSellPriceIncVat from "@/components/products/ProductQuickEditSellPriceIncVat.vue";
import AppProductQuickEditMainSupplierBuyCatalogPrice from "@/components/products/ProductQuickEditMainSupplierBuyCatalogPrice.vue";
import AppProductQuickEditMainSupplierBuyNettoPrice from "@/components/products/ProductQuickEditMainSupplierBuyNettoPrice.vue";
import { BrowsePermissions } from "@/models/user-configs/browse-permissions";
import { DossierConfigService, UserConfigService } from "@/services";
import SaleRowExtraFields from "@/models/base/sale-row-extra-fields";
import AppCreateAutomaticAfleveringsbonnenOfDeliveredGoodsModal from "./CreateAutomaticAfleveringsbonnenOfDeliveredGoodsModal.vue";


interface IQuickEditSellPriceData {
	category:number;
	product:Product;
	row:SaleRow;
}

export default Vue.extend({
	data(){
		return{
			selectedBookYear: `${BookYearService.selectedBookYear}`,
			markAsDeliveredRow: null as null | SaleRow,
			editDeliveryDate: false,
			markAsDeliverdDate: null as null | Date,
			browseState: null as null | BrowseState,
			isMarkingAsDelivered: false,
			quickEditSellPriceModal: null as null | IQuickEditSellPriceData,
			quickEditSellPriceIncVatModal: null as null | IQuickEditSellPriceData,
			toQuickEditPriceRow: null as null | SaleRow,
			toQuickEditMainSupplierCatalogPriceProduct: null as null | Product,
			toQuickEditMainSupplierNettoPriceProduct: null as null | Product,
			createAutomaticAfleveringsbonnenOfDeliveredGoodsModalOpen: false
		};
	},
	props: {
		selectedItems: {
			type: Array as ()=>SaleRow[],
			default: ()=>[]
		},
		contactId: {
			type: Number,
			default: 0
		},
		excludeSaldos: Boolean,
		showReports: Boolean,
		bookYearSelect: {
			type: Boolean,
			default: false
		},
		showActions: Boolean,
		browseId: {
			type: Number,
			required: true
		}
	},
	computed: {
		service():SaleRowServiceClass{
			if (this.browseId == 7){
				return SaleRowService;
			}
			return PurchaseDocumentRowService;
		},
		extraFilters():HumanFilter[] {
			let result:HumanFilter[] = [];
			if (this.contactId != 0) {
				let filter = new HumanFilter();
				filter.Field = "this_Sale.ContactID";
				filter.Operator = "=";
				filter.Values = [`${this.contactId}`];
				result.push(filter);
			}
			if (this.excludeSaldos) {
				let filter = new HumanFilter();
				filter.Field = "this_Sale.ComputedFriendlyID";
				filter.Operator = "!^";
				filter.Values = ["-"];
				result.push(filter);
			}
			return result;
		},
		contactGroupId():number {
			if (this.browseId == 7) return 1;
			return 2;
		},
		// eslint-disable-next-line max-lines-per-function
		dataSource(): IBrowseDataSource<SaleRow> {
			let t = this;
			let browseName = "SaleDetails";
			if (this.browseId == 17) {
				browseName = "PurchaseDocumentDetails";
			}
			return {
				getSettings: () => BrowseService.getBrowse(this.browseId),
				getElements: async (params: IQueryParams) => {
					let result = await this.service.getSalesRows(params, t.extraFilters, t.selectedBookYear);
					for (let item of result.data){
						if (item.ExtraFields == null){
							item.ExtraFields = new SaleRowExtraFields();
						}
					}
					return result;
				},
				browseName,
				modelName: "SaleRow",
				getTotals(view: View): Promise<FetchedTotal[]> {
					return t.service.getTotals(view);
				},
				getOnElementUpdateSocketEvent: (item: SaleRow) => `/purchase-document-row/${item.ID}/update`,
				onSocketElementUpdated: (data: any) => new SaleRow(data),
				async getFullElement(el: SaleRow): Promise<SaleRow> {
					return new SaleRow();
				},
				addRoute: "",
				edit (element: SaleRow) {
					return;
				},
				extraFieldSettings: {
					getExtraFields: SaleRowService.getExtraFields.bind(SaleRowService),
					nameSettings: DossierConfigService.getExtraFieldNamesConfigs().SaleRowNames,
					batchEdit: SaleRowService.batchEditExtraField.bind(SaleRowService),
					edit: (SaleRowService.updateExtraFields as any).bind(SaleRowService)
				},
				async delete (elements: SaleRow[]): Promise<boolean> {
					return false;
				},
				browsePermissions (): BrowsePermissions {
					return UserConfigService.getPermissionSettings().getPermissionsByBrowseID(t.browseId);
				},
			};
		},
		createAfleveringsBonnenItem():ISelectItem<Function>{
			return {
				text: this.$ct("create-afleveringsbonnen-of-delivered-goods"),
				value: this.createAfleveringsbonnenOfDeliveredGoods,
				icon: "file-invoice"
			};
		},
		contextMenuItems():ISelectItem<string | Function>[]{
			if (!this.showActions) {
				return [];
			}
			let result = [] as ISelectItem<string | Function>[];
			if (AuthService.hasModule(MODULE.BACKORDERBEHEER)){
				result.push(
					{
						text: this.$ct("mark-as-delivered"),
						value: "markAsDelivered",
						icon: "warehouse",
						disabled: this.isMarkingAsDelivered
					},
					{
						text: this.$ct("mark-as-undeliverable"),
						value: "markAsUndeliverable",
						icon: "box-open"
					},
					this.createAfleveringsBonnenItem,
				);
				if(this.browseState?.contextMenu.item?.Undeliverable){
					result[1] =
						{
							text: this.$ct("mark-as-deliverable"),
							value: "markAsDeliverable",
							icon: "box",
						}
					;
					return result;
				}
			}
			return result;
		},
		buttonBarItems():ISelectItem<Function | string>[]{
			if (!this.showActions) {
				return [];
			}
			if (AuthService.hasModule(MODULE.BACKORDERBEHEER)){
				return [
					this.createAfleveringsBonnenItem
				];
			}
			return [];
		}
	},
	methods: {
		info() {
			if(!this.selectedItems[0]){
				return;
			}
			if (this.browseId == 7){
				this.$router.push(`/sales/info/${this.selectedItems[0].SaleID}`);
				return;
			}
			this.$router.push(`/purchase-documents/info/${this.selectedItems[0].SaleID}`);
		},
		refresh(){
			let browse = this.$refs.browse as any;
			if (!browse) return;
			browse.refresh();
		},
		onBookYearChange(bookyear:string) {
			this.selectedBookYear = bookyear;
			this.refresh();
		},
		onMarkAsDelivered(row:SaleRow){
			if (this.selectedItems.length > 1){
				this.editDeliveryDate = true;
				return;
				//return this.markAsDelivered();
			}
			if (row.Backorder == 0) return;
			this.markAsDeliveredRow = row;
		},
		async markAsDelivered(event?:SaleRow){
			let items = [...this.selectedItems];
			if (items.length == 0 && event){
				items = [event];
			}
			if (this.isMarkingAsDelivered) return;
			this.isMarkingAsDelivered = true;
			try{
				let response = await this.service.markAsDelivered(items);
				if (response.undeliverableCount > 0) {
					this.$wf.notify(this.$ctc("sale-rows-set-to-undelivered", response.undeliverableCount), "info", 3000, "info-circle");
				}
				this.$wf.notify(this.$ctc("rows-changed-count", response.changedRows), "success", 3000, "check");
				this.refresh();
			}catch(err){

			}finally{
				this.isMarkingAsDelivered = false;
			}
		},
		async markAsUndeliverable(event?:SaleRow){
			let rows = [...this.selectedItems];
			if (rows.length == 0 && event){
				rows = [event];
			}
			let confirmText = this.$ctc("are-you-sure-you-want-to-mark-count-rows-as-undeliverable", rows.length).toString();
			let confirm = await this.$confirmBuilder(confirmText).setWarningTitle().show();
			if (!confirm) {
				return;
			}
			await this.service.markAsUndeliverable(rows);
			this.deselectAllItems();
			this.refresh();
		},
		async markAsDeliverable(event?:SaleRow){
			let rows = [...this.selectedItems];
			if (rows.length == 0 && event){
				rows = [event];
			}
			let confirmText = this.$ctc("are-you-sure-you-want-to-mark-count-rows-as-deliverable", rows.length).toString();
			let confirm = await this.$confirmBuilder(confirmText).setWarningTitle().show();
			if (!confirm) {
				return;
			}
			try{
				await this.service.markAsDeliverable(rows);
				this.refresh();
			}catch(err){

			}
		},
		onBackorderRowBooked(row:SaleRow){
			this.refresh();
		},
		async createAfleveringsbonnenOfDeliveredGoods(){
			this.createAutomaticAfleveringsbonnenOfDeliveredGoodsModalOpen = true;
		},
		deselectAllItems(){
			this.selectedItems.splice(0, this.selectedItems.length);
		},
		onMarkedAsDelivered(){
			this.deselectAllItems();
			this.refresh();
		},
		quickEditSellPrice(row:SaleRow, product:Product, category:number){
			this.quickEditSellPriceModal = {
				category,
				product,
				row
			};
		},
		quickEditSellPriceIncVat(row:SaleRow, product:Product, category:number){
			this.quickEditSellPriceIncVatModal = {
				category,
				product,
				row
			};
		},
		async onColClick(result:string, value:SaleRow){
			if (result.startsWith("edit-sell-price/")){
				let category = parseInt(result.replaceAll("edit-sell-price/Product.", ""));
				if (!category || Number.isNaN(category) || !value.Product) return;
				this.quickEditSellPrice(value, value.Product, category);
			}else if (result.startsWith("edit-sell-price-inc-vat/")){
				let category = parseInt(result.replaceAll("edit-sell-price-inc-vat/Product.", ""));
				if (!category || Number.isNaN(category)  || !value.Product) return;
				this.quickEditSellPriceIncVat(value, value.Product, category);
			}else if (result == "edit-buy-netto-price"){
				if(!value.Product) return;
				this.toQuickEditPriceRow = value;
				this.toQuickEditMainSupplierNettoPriceProduct = value.Product;
			}else if (result == "edit-buy-catalog-price"){
				if(!value.Product) return;
				this.toQuickEditPriceRow = value;
				this.toQuickEditMainSupplierCatalogPriceProduct = value.Product;
			}else if (result == "edit-validated"){
				if(!value) return;
				await SaleRowService.markAsValidated([value]);

				//this.refresh();
			}
		},
		async refreshRow(row:SaleRow){
			//Todo should I refresh row? but product is returned, not salerow
			this.refresh();
		}
	},
	components: {
		AppBrowse,
		AppSelectBookYear,
		AppMarkAsDelivered,
		AppMarkAsDeliveredDate,
		AppProductQuickEditSellPrice,
		AppProductQuickEditSellPriceIncVat,
		AppProductQuickEditMainSupplierBuyCatalogPrice,
		AppProductQuickEditMainSupplierBuyNettoPrice,
		AppCreateAutomaticAfleveringsbonnenOfDeliveredGoodsModal

	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
